function observeReveals(root = document) {
  const reveals = root.querySelectorAll(".reveal:not(.is-visible)")
  if (!reveals.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible")
          observer.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
  )

  reveals.forEach((el) => observer.observe(el))
}

function initLandingAnimations() {
  observeReveals()
}

document.addEventListener("DOMContentLoaded", initLandingAnimations)